import { Organization } from '../../services/models/Organization'
import { Owner } from '../../services/models/Owner'

export const buildOrganization = (miniapp: any) => {
    const org = miniapp.organization
    const owner: Owner = org.owner
    let organization: Organization

    if (org && org.id) {
        organization = {
            id: org.id,
            name: org.name,
            owner,
        }
    } else {
        organization = {
            name: org.name,
            owner,
        }
    }
    return organization
}

export const initializeOrganization = (userEmail: any) => {
    const owner: Owner = { email: userEmail }
    const organization: Organization = {
        name: '',
        owner: owner,
    }
    return organization
}
